import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const KPICardWidget = ({ config = {}, data = null, isPreview = false }) => {
  // Demo/preview data when no real data
  const demoData = {
    organic_traffic: { value: null, change: null, label: 'Organic Traffic' },
    keyword_rankings: { value: null, change: null, label: 'Keyword Rankings' },
    avg_position: { value: null, change: null, label: 'Avg. Position' },
    domain_authority: { value: null, change: null, label: 'Domain Authority' },
    backlinks_total: { value: null, change: null, label: 'Total Backlinks' },
    referring_domains: { value: null, change: null, label: 'Referring Domains' },
    site_health_score: { value: null, change: null, label: 'Site Health Score' },
    pages_indexed: { value: null, change: null, label: 'Pages Indexed' },
    ai_visibility_score: { value: null, change: null, label: 'AI Visibility' },
    ad_spend: { value: null, change: null, label: 'Ad Spend' },
    ad_clicks: { value: null, change: null, label: 'Ad Clicks' },
    ad_impressions: { value: null, change: null, label: 'Ad Impressions' },
    ctr: { value: null, change: null, label: 'CTR' },
    cpc: { value: null, change: null, label: 'Avg. CPC' },
    conversions: { value: null, change: null, label: 'Conversions' },
    conversion_rate: { value: null, change: null, label: 'Conversion Rate' },
    cost_per_conversion: { value: null, change: null, label: 'Cost per Conversion' },
    roas: { value: null, change: null, label: 'ROAS' },
    sessions: { value: null, change: null, label: 'Sessions' },
    users: { value: null, change: null, label: 'Users' },
    bounce_rate: { value: null, change: null, label: 'Bounce Rate' },
    gsc_clicks: { value: null, change: null, label: 'Search Clicks' },
    gsc_impressions: { value: null, change: null, label: 'Search Impressions' },
    gsc_ctr: { value: null, change: null, label: 'Search CTR' },
    gsc_avg_position: { value: null, change: null, label: 'Search Avg. Position' }
  };

  const metricKey = config.metric || 'organic_traffic';
  const displayData = data || demoData[metricKey] || demoData.organic_traffic;
  const color = config.color || '#3B82F6';

  // No real data bound: show an empty state rather than demo numbers.
  const hasValue = displayData && displayData.value !== null && displayData.value !== undefined;
  if (!hasValue) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center text-center p-4">
        <div className="text-3xl font-bold text-gray-300 leading-none">&mdash;</div>
        <div className="text-sm text-gray-500 mt-2">{(displayData && displayData.label) || 'Metric'}</div>
        <div className="text-xs text-gray-400 mt-1">No data source connected</div>
      </div>
    );
  }


  const formatValue = (val) => {
    if (config.format === 'currency') return `$${val.toLocaleString()}`;
    if (config.format === 'percentage') return `${val}%`;
    if (config.format === 'decimal') return val.toFixed(1);
    return val.toLocaleString();
  };

  const getTrendIcon = (change) => {
    if (change > 0) return <TrendingUp className="w-4 h-4" />;
    if (change < 0) return <TrendingDown className="w-4 h-4" />;
    return <Minus className="w-4 h-4" />;
  };

  const getTrendColor = (change, metric) => {
    // For avg_position, lower is better
    const invertedMetrics = ['avg_position'];
    const isInverted = invertedMetrics.includes(metric);
    if (change > 0) return isInverted ? 'text-red-500' : 'text-emerald-500';
    if (change < 0) return isInverted ? 'text-emerald-500' : 'text-red-500';
    return 'text-gray-400';
  };

  return (
    <div className="h-full flex flex-col justify-center p-4 bg-white rounded-lg">
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
        {displayData.label || config.title || 'Metric'}
      </p>
      <div className="flex items-end gap-3">
        <span className="text-2xl font-bold text-gray-900" style={{ color }}>
          {formatValue(displayData.value)}
        </span>
        {config.showTrend !== false && displayData.change !== undefined && (
          <div className={`flex items-center gap-1 text-sm font-medium ${getTrendColor(displayData.change, metricKey)}`}>
            {getTrendIcon(displayData.change)}
            <span>{Math.abs(displayData.change)}%</span>
          </div>
        )}
      </div>
      {config.comparisonPeriod && (
        <p className="text-xs text-gray-400 mt-1">vs. previous period</p>
      )}
    </div>
  );
};

export default KPICardWidget;
